var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.09014 6.65498L11.4393 6.68615C12.6528 6.66382 13.4124 6.45362 14.1852 5.98611C14.6008 5.73462 15.1624 5.76301 15.5341 6.13533C15.9598 6.56169 16.0133 7.24763 15.5685 7.6932C15.1236 8.13876 5.28862 17.9897 5.28862 17.9897C5.27972 17.9987 5.27968 18.0131 5.28854 18.022L5.98947 18.7241C5.99835 18.733 6.01276 18.7329 6.02168 18.724L16.3015 8.42743C17.2063 7.52118 18.6507 8.75407 18.0009 9.81619C17.5144 10.6113 17.29 11.3985 17.2869 12.7102L17.3356 16.9197C17.3357 16.9321 17.3457 16.942 17.358 16.9421L18.3025 16.9531C18.3154 16.9533 18.3259 16.9427 18.3257 16.9298L18.3804 5.65459C18.3801 5.64235 18.3703 5.6325 18.3581 5.63231L7.07995 5.66461C7.06712 5.66441 7.05656 5.67492 7.05671 5.6878L7.06766 6.63254C7.06781 6.64493 7.0778 6.65488 7.09014 6.65498Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.14589001f0fcfb408656deb07fbee7df.svg";
export { ForwardRef as ReactComponent };